import { useMemo } from "react";
import usePermissions from "../../../../../hooks/usePermissions";

/** Project-scoped API Security RBAC helpers (api_security:read|configure|write|delete). */
export default function useAsecPermissions() {
  const { hasPermission, PERMISSIONS } = usePermissions();

  return useMemo(() => ({
    canRead: hasPermission(PERMISSIONS.API_SECURITY_READ),
    canConfigure: hasPermission(PERMISSIONS.API_SECURITY_CONFIGURE),
    canWrite: hasPermission(PERMISSIONS.API_SECURITY_WRITE),
    canDelete: hasPermission(PERMISSIONS.API_SECURITY_DELETE),
    /** Policy / mode / enforcement toggles — maps to api_security:configure on the API. */
    canSavePolicy: hasPermission(PERMISSIONS.API_SECURITY_CONFIGURE),
    PERMISSIONS,
  }), [hasPermission, PERMISSIONS]);
}
